/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';

import StyledMarkdown from './Markdown.styled';

function Markdown({children, ...rest}) {
  return (
    <StyledMarkdown>
      <ReactMarkdown {...rest}>{children}</ReactMarkdown>
    </StyledMarkdown>
  );
}

Markdown.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Markdown;
